import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";

export default function ImpersonateLanding() {
  const history = useHistory();

  useEffect(() => {
    const p      = new URLSearchParams(window.location.search);
    const token  = p.get("token");
    const xsrf   = p.get("xsrf");

    // write cookies for *this* host (`app.localhost`)
    if (token) Cookies.set("JWT", token,  { path: "/", expires: 1/288 }); // 5 min = 5/1440 day
    if (xsrf)  Cookies.set("XSRF-TOKEN", xsrf, { path: "/", expires: 1/288 });

    history.replace("/");   // go to dashboard
  }, [history]);

  return null;              // nothing to render
}
